import Vue from 'vue';

export default {
  install() {
    Vue.prototype.$confirm = (text, {
      yesOrNo = false,
      cancelText = 'CANCEL',
      okText = 'OK_BUTTON',
      hidePage = false,
      closeManually = false,
    } = {}) => new Promise((resolve, reject) => {
      Vue.prototype.$modal.show('dialog', {
        text, yesOrNo, okText, cancelText, hidePage, closeManually, resolve, reject,
      });
    });

    Vue.prototype.$prompt = (text, value = '', {
      yesOrNo = false,
      cancelText = 'CANCEL',
      okText = 'OK_BUTTON',
      validate,
      hidePage = false,
      closeManually = false,
    } = {}) => new Promise((resolve, reject) => {
      Vue.prototype.$modal.show('dialog', {
        text,
        value,
        yesOrNo,
        okText,
        cancelText,
        validate,
        input: true,
        hidePage,
        closeManually,
        resolve,
        reject,
      });
    });

    Vue.prototype.$alert = (text, { okText = 'OK_BUTTON', hidePage = false, closeManually = false } = {}) => new Promise((resolve, reject) => {
      Vue.prototype.$modal.show('dialog', {
        text, okText, isAlert: true, hidePage, closeManually, resolve, reject,
      });
    });
  },
};
